import { render, staticRenderFns } from "./FormInfoItem.vue?vue&type=template&id=75439351&scoped=true&"
import script from "./FormInfoItem.vue?vue&type=script&lang=js&"
export * from "./FormInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./FormInfoItem.vue?vue&type=style&index=0&id=75439351&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75439351",
  null
  
)

export default component.exports